export default __webpack_public_path__ + "static/media/1311.72f895b8.jpg";